import { Link } from "react-router-dom";
import { usePageSeo } from "../lib/seo";

export default function NotFound({ robots = "noindex,nofollow", canonicalPath } = {}) {
  usePageSeo({
    title: "Page not found — Urban Turban by VeerGi",
    description: "The page you're looking for doesn't exist.",
    robots,
    canonicalPath,
  });

  return (
    <main data-testid="not-found-page" className="min-h-[60vh] flex flex-col items-center justify-center gap-5 px-6 text-center">
      <p className="tracking-[0.3em] uppercase text-xs text-neutral-400" data-testid="not-found-code">404</p>
      <h1 className="font-display text-3xl sm:text-4xl font-extrabold">Page not found</h1>
      <p className="text-neutral-500 max-w-md text-sm">
        This page doesn't exist or has moved. The kitchen's still open, though.
      </p>
      <div className="flex flex-wrap items-center justify-center gap-3 mt-2">
        <Link to="/store/restaurant" data-testid="not-found-menu-link"
          className="px-6 py-2.5 rounded-full bg-black text-white text-sm font-bold">See the menu</Link>
        <Link to="/" data-testid="not-found-home-link"
          className="px-6 py-2.5 rounded-full border border-neutral-300 text-sm font-bold">Home</Link>
        <Link to="/locations" data-testid="not-found-locations-link"
          className="px-6 py-2.5 rounded-full border border-neutral-300 text-sm font-bold">Locations</Link>
      </div>
    </main>
  );
}
